import { BoxGeometry, DataTexture, Group, Mesh, MeshStandardMaterial, Object3D, RGBAFormat, UnsignedByteType } from "three";

export function createSyntheticStackUnit(): Group {
  const root = new Group();
  root.name = "synthetic-stack-unit";
  root.userData.assetNodeId = "stack-unit-root";
  const geometry = new BoxGeometry(1, 0.75, 0.75);
  geometry.clearGroups();
  const material = new MeshStandardMaterial({ color: 0xf3c969 });
  material.userData.materialId = "stack-unit-material";
  const texture = new DataTexture(new Uint8Array(16 * 16 * 4), 16, 16, RGBAFormat, UnsignedByteType);
  texture.generateMipmaps = false;
  texture.userData.assetTextureDescriptor = {
    atlasId: "sunpatch-shared-palette-v1", faces: 1, format: "rgba8-unorm", height: 16, layers: 1, mipmapped: false,
    sourceSha256: "bbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbb",
    textureId: "stack-unit-palette", width: 16,
  };
  material.map = texture;
  const mesh = new Mesh(geometry, material);
  mesh.position.y = 0.375;
  mesh.userData.assetNodeId = "stack-unit-visible";
  root.add(mesh);
  const socket = new Object3D();
  socket.name = "topSocket";
  socket.position.y = 0.75;
  root.add(socket);
  return root;
}
